import { useStartAPetitionPageData } from '../../../../pageData';
import { DEFAULT_CONFIG } from '../../configs';
import type { StepConfig } from '../../types';

export function useCurrentSteps(): StepConfig[] {
	const {
		data: { featureConfigs },
	} = useStartAPetitionPageData();

	const getDefaultSteps = (): StepConfig[] => {
		return DEFAULT_CONFIG.filter((step: StepConfig) => {
			return step.isEnabled(featureConfigs);
		});
	};

	return getDefaultSteps();
}
